import { StatusOptions } from 'containers/gps-outside-project-report/GpsOutsideProjectReportSidePanel/GpsOutsideProjectReportSidePanel';
import TimeRangeType from 'types/TimeRangeType';
import useNavigation from './useNavigation';

interface IParams {
  start_date?: string;
  end_date?: string;
  time_range_type?: TimeRangeType;
  flagged_location_status?: StatusOptions;
}

export default function useGPSOutsideProjectReportNavigation() {
  return useNavigation<IParams>('/flagged-location-report');
}
